import React from 'react';
import algoliasearch from 'algoliasearch';

export const AlgoliaConnectorContext = React.createContext<ReturnType<typeof algoliasearch>>(
    {} as ReturnType<typeof algoliasearch>
);
